import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar";
import { isLoggedIn, selectToken } from "../login/loginSlice";
import { selectUser } from "../home/userSlice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadStatements, selectStatements, statementsLoading } from "./statementsSlice";

export default function Statements() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector(selectToken);
    const loggedIn = useSelector(isLoggedIn);
    const userInfo = useSelector(selectUser);
    const username = userInfo.username;
    const userRole = userInfo.userRole;

    const statements = useSelector(selectStatements);
    const loadingStatements = useSelector(statementsLoading);

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    useEffect(() => {
        if (userRole !== 'USER') {
            navigate(`../home`);
        } else if (statements.length < 1) {
            dispatch(loadStatements({username, token}))
        }
    }, [userRole, statements, username, token, navigate, dispatch])

    const handleStatementDownload = async event => {
        await fetch(`${process.env.REACT_APP_BASE_URL}/user/statements/download/${event.target.textContent}`,
            {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        )
        .then(response => response.blob())
        .then(response => {
            const url = URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = url;
            link.download = event.target.textContent;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        });        
    }

    return (
        <main>
            <Sidebar />
            {loadingStatements ? <h2>Loading Statements...</h2> : 
                <section>
                    <h2>Statements</h2>
                    {statements.map(statement => {
                        return (
                            <div>
                                <h3 onClick={handleStatementDownload}>{statement}</h3>
                            </div>
                        )
                    })}
                </section>
            }
        </main>
    )
}